import { useLoaderData } from '@remix-run/react';
import { WEBVIEW_IFRAME_SANDBOX } from '~/utils/iframe-sandbox.ts';

type LoaderData = {
  screen: any;
  webviewUrl: string | undefined;
};

export function WebView(): JSX.Element {
  const { screen, webviewUrl } = useLoaderData<LoaderData>();

  if (!webviewUrl) return <></>;

  return (
    <div className={`screen-${screen.id} screen-classes h-screen`}>
      <iframe
        title={screen?.general?.webview_accessibility_title || 'iframe'}
        sandbox={WEBVIEW_IFRAME_SANDBOX}
        src={webviewUrl}
        className="h-full w-full"
      />
    </div>
  );
}
